import React, { useCallback, useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { Trans, useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router';
import { route } from '../../../../services/utils';
import { CROP_FIELD_IMPORT } from '../../../../router/routes';
import {
  ButtonComponent,
  ButtonStyling,
} from '../../../../components/form/elements/button';
import modalCss from '../../../../components/modals/modal.module.css';
import css from '../index.module.css';

interface Props {
  onConfirm: () => void;
  onCancel: () => void;
  visible?: boolean;
}

export default function TutorialModal({
  onConfirm,
  onCancel,
  visible = true,
}: Props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { farmId, year } = useParams<{ farmId: string; year: string }>();
  const [modalVisible, setModalVisible] = useState(visible);
  useEffect(() => setModalVisible(visible), [visible]);

  const closeModal = useCallback(() => {
    setModalVisible(false);
    onCancel();
  }, [setModalVisible, onCancel]);

  const body = (
    <>
      <div className={css['list-warning']}>
        <Trans
          i18nKey="pages.crop.vaad_liz_reports_v2.tutorial_modal.content"
          components={{ 1: <br /> }}
        />
      </div>
    </>
  );

  const onChoice = useCallback(
    (choice: string) => {
      if (choice === 'confirm') {
        onConfirm();
      } else if (choice === 'link') {
        const routeTo = route(CROP_FIELD_IMPORT, { farmId, season: year });

        history.push(routeTo);
      } else {
        onCancel();
      }
    },
    [onConfirm, farmId, year, history, onCancel]
  );

  const buttons = (
    <>
      <ButtonComponent
        key="tutorial-modal-cancel"
        name="tutorial-modal-cancel"
        label={t('pages.crop.vaad_liz_reports_v2.tutorial_modal.cancel')}
        styling={ButtonStyling.cancel}
        click={() => onChoice('cancel')}
      />
      <ButtonComponent
        key="tutorial-modal-link"
        name="tutorial-modal-link"
        label={t('pages.crop.vaad_liz_reports_v2.tutorial_modal.link')}
        styling={ButtonStyling.secondary}
        click={() => onChoice('link')}
      />
      <ButtonComponent
        key="tutorial-modal-confirm"
        name="tutorial-modal-confirm"
        label={t('pages.crop.vaad_liz_reports_v2.tutorial_modal.confirm')}
        styling={ButtonStyling.primary}
        click={() => onChoice('confirm')}
      />
    </>
  );

  return (
    <ReactModal
      isOpen={modalVisible}
      onRequestClose={closeModal}
      className={css['tutorial-modal']}
      overlayClassName={modalCss['overlay']}
      shouldCloseOnOverlayClick={true}
    >
      <div className={modalCss['content']} data-name="tutorial-modal">
        {body && <div className={modalCss['body']}>{body}</div>}
        {buttons && <div className={modalCss['buttons']}>{buttons}</div>}
      </div>
    </ReactModal>
  );
}
